import axios from "axios";
import toast from "react-hot-toast";
const BASE__URL = process.env.REACT_APP_API_BASE_URL;

export const getAdsList = (adsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ADS_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE__URL}/banner-ad/list`,
        adsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_ADS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_ADS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_ADS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAdsBanners = (adsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_ADS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE__URL}/banner-ad/add`,
        adsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_ADS_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_ADS_FAILED", payload: data });
        toast.error("Something Wrong Happened!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_ADS_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const viewAdBanner = (id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_ADS_REQUEST" });

      const { data } = await axios.get(`${BASE__URL}/banner-ad/view/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_ADS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_ADS_FAILED", payload: data });
        toast.error("Failed to fetch details.");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_ADS_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message || "Something went wrong.");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const editAdBanner = (id,adsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_ADS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE__URL}/banner-ad/update`,
        id,
        adsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_ADS_SUCCESS", payload: data });
        toast.success("Updated Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_ADS_FAILED", payload: data });
        toast.error("Failed to update ad.");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_ADS_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message || "Something went wrong.");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const deleteAdBanner = (id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_ADS_REQUEST" });

      const { data } = await axios.delete(`${BASE__URL}/banner-ad/remove/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_ADS_SUCCESS", payload: data });
        toast.success("Deleted Successfully!");
        return data;
      } else {
        dispatch({ type: "DELETE_ADS_FAILED", payload: data });
        toast.error("Failed to delete ad.");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "DELETE_ADS_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message || "Something went wrong.");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


